import React, { useEffect, useState } from "react";
import { Banner, Button, Detail, H3, Modal, Textarea } from "@maggioli-design-system/react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { sendFeedback } from "../services/AIpen";
import { IFeedback } from "../Interfaces/IFeedback";
import { ICON_BUTTON } from "../lib/A11y";

interface IFeedbackModal {
    jobID: number,
    show: boolean,
    setShow: Function,
    defaultRank: boolean,
    givenFeedback: IFeedback | false,
    updateFeedback: Function,
}

const FeedbackModal = ({ jobID, show, setShow, defaultRank, givenFeedback, updateFeedback }: IFeedbackModal): JSX.Element => {

    const [feedbackResponse, setFeedbackResponse] = useState<boolean>(false);
    const [feedbackMessage, setFeedbackMessage] = useState<string>("");
    const [rank, setRank] = useState<boolean>(defaultRank);
    const [feedbackText, setFeedbackText] = useState<string>("");

    useEffect(() => {
        if (!show) {
            setFeedbackText("");
            setFeedbackResponse(false);
            setFeedbackMessage("");
            setRank(defaultRank);
        }
    }, [show])

    useEffect(() => {
        setRank(defaultRank);
    }, [defaultRank])

    const onClickSendFeedback = async () => {
        const payload = {
            "vote": rank,
            "job_id": jobID,
            "comment": feedbackText
        }
        sendFeedback(payload).then(res => {
            if (res.status !== 200) {
                alert("Errore nell'invio del feedback");
                return;
            }
            setFeedbackResponse(res.data.status);
            setFeedbackMessage(res.data.message);
            updateFeedback({ id: 0, comment: feedbackText, vote: rank }, jobID);
        })
    }

    const onClickThumbs = (vote: boolean) => {
        if(givenFeedback) {
            return;
        }
        setRank(vote);
    }

    return <Modal visible={show} position="center" onCancel={() => setShow(false)} wide={true} footer={false}>
        <H3 className="mb-3">{givenFeedback ? "Feedback fornito" : "Fornisci feedback" }</H3>
        
        <button aria-label="Valutazione positiva" aria-pressed={rank === true} className={`${ICON_BUTTON} mb-1 mr-3`}
            disabled={givenFeedback !== false} onClick={() => onClickThumbs(true)} type="button">
            <FontAwesomeIcon aria-hidden="true" icon={faThumbsUp} className={"h-8 " + (rank && "text-brand-maggioli-07")}/>
        </button>
        <button aria-label="Valutazione negativa" aria-pressed={rank === false} className={ICON_BUTTON}
            disabled={givenFeedback !== false} onClick={() => onClickThumbs(false)} type="button">
            <FontAwesomeIcon aria-hidden="true" icon={faThumbsDown} className={"h-8 " + (rank === false && "text-brand-maggioli-07")}/>
        </button>

        { givenFeedback ? 
            <Detail>{givenFeedback.comment}</Detail>
        : show ? <Textarea value={feedbackText} onChange={e => setFeedbackText(e.target.value)}
            placeholder="Se vuoi puoi aggiungere un breve parere sulla qualità/correttezza del contenuto generato dall'IA..."/> : <></> }
        
        {/* L'esito dell'invio va annunciato alle tecnologie assistive */}
        <div aria-live="polite" role="status">
            { feedbackMessage !== "" &&
                <Banner status={feedbackResponse ? "success" : "warning"} className="w-full rounded-2xl text-secondary text-secondary--detail mt-3">
                    {feedbackResponse ? "Feedback inviato con successo!" : feedbackMessage}
                </Banner>}
        </div>
        { !givenFeedback && <Button className="mt-3" disabled={rank === null || feedbackResponse} onClick={() => onClickSendFeedback()}>Invia</Button> }
    </Modal>
};

export default FeedbackModal;
